export default "__VITE_ASSET__CAOva$x___"